import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Popover from 'material-ui/Popover';

import { withTranslation } from 'react-i18next';

import ImageLoader from '../Shared/ImageLoader/ImageLoader';
import { getImageLink } from 'helpers/imageHelper';
import { imageSizes } from 'config/constants';
import './style.css';

class StackSelectorDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accounts: props.accountsList || [],
      searchQuery: '',
    };
  }

  componentDidUpdate(prevProps) {
    // Reset search when popover opens
    if (prevProps.open !== this.props.open && this.props.open) {
      this.setState({
        accounts: this.props.accountsList || [],
        searchQuery: '',
      });
    }
  }

  handleSearch = (event) => {
    var query = event.target.value;
    var accountsList = this.props.accountsList || [];

    this.setState({ searchQuery: query });

    if (query.length === 0) {
      this.setState({ accounts: accountsList });
      return;
    }

    var lowerQuery = query.toLowerCase();
    var filtered = accountsList.filter(function (item) {
      return item.name && item.name.toLowerCase().indexOf(lowerQuery) !== -1;
    });

    this.setState({ accounts: filtered });
  };

  handleAccountClick = (uuid) => {
    this.props.onSwitchAccount(uuid);
    this.props.onClose();
  };

  handleAddClick = () => {
    this.props.onClose();
    this.props.onAddStackClick();
  };

  render() {
    var _this = this;
    var props = this.props;
    var state = this.state;
    var open = props.open;
    var anchorEl = props.anchorEl;
    var onClose = props.onClose;
    var imagesLinks = props.imagesLinks;
    var t = props.t;
    var accounts = state.accounts;
    var searchQuery = state.searchQuery;

    return (
      <Popover
        open={open}
        anchorEl={anchorEl}
        onRequestClose={onClose}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        className="stack-selector-dropdown-popover"
        zDepth={0}
        style={{
          marginTop: 8,
          background: 'transparent',
          boxShadow: 'none',
          overflow: 'visible',
          borderRadius: 12,
        }}
      >
        <div className="stack-selector-dropdown">
          <div className="stack-selector-dropdown-header">
            <div className="stack-selector-dropdown-search">
              <span className="material-symbols-outlined stack-selector-dropdown-search-icon">search</span>
              <input
                className="stack-selector-dropdown-search-input"
                placeholder={t('stackSettings:searchMyStacks')}
                value={searchQuery}
                onChange={this.handleSearch}
              />
            </div>
            <button
              className="stack-selector-add-btn"
              onClick={this.handleAddClick}
            >
              <span className="material-symbols-outlined" style={{ fontSize: 14 }}>add</span>
              {t('stackSettings:addStack')}
            </button>
          </div>

          <div className="stack-selector-dropdown-content">
            {accounts.map(function (account) {
              var link = getImageLink(
                account.imageUUID,
                imagesLinks,
                imageSizes.ACCOUNT_LIST
              );
              var firstLetter = account.name ? account.name[0].toUpperCase() : '';

              return (
                <div
                  key={account.uuid}
                  className="stack-selector-item"
                  onClick={function () { _this.handleAccountClick(account.uuid); }}
                >
                  <div className="stack-selector-item-avatar">
                    {link && (
                      <ImageLoader
                        url={link}
                        spinnerWidth={imageSizes.ACCOUNT_LIST.width / 2}
                      />
                    )}
                    {!link && firstLetter}
                  </div>
                  <div className="stack-selector-item-name">
                    {account.name}
                  </div>
                </div>
              );
            })}
            {accounts.length === 0 && (
              <div className="stack-selector-dropdown-empty">
                {t('stackSettings:noStacksFound')}
              </div>
            )}
          </div>
        </div>
      </Popover>
    );
  }
}

StackSelectorDropdown.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSwitchAccount: PropTypes.func.isRequired,
  onAddStackClick: PropTypes.func.isRequired,
  accountsList: PropTypes.array,
  imagesLinks: PropTypes.object,
  t: PropTypes.func.isRequired,
};

var mapStateToProps = function (state) {
  return {
    accountsList: state.accounts.accountsList,
    imagesLinks: state.images.links,
  };
};

export default withTranslation()(connect(mapStateToProps)(StackSelectorDropdown));
